import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { Question } from '../../config/types';
import type { FetchFormResponse } from '../../service/types';
import { evaluateAutoFillCondition } from '../../utils/autofill-condition';

type Props = {
  question: Question;
  answers?: FetchFormResponse['answers'];
};

export default function AutoFillCondition({ question, answers }: Props) {
  const { autoFillCondition } = question;
  const methods = useFormContext<FetchFormResponse['answers']>();
  const allValues = useWatch({ control: methods.control }) as Record<string, unknown> | undefined;

  useEffect(() => {
    if (!autoFillCondition) return;

    const values = {
      ...(answers ?? {}),
      ...(methods.getValues() ?? {}),
      ...(allValues ?? {}),
    };
    const next = evaluateAutoFillCondition(autoFillCondition, values);
    const current = methods.getValues(question.name);

    if (String(current ?? '') !== next) {
      methods.setValue(question.name, next, {
        shouldDirty: false,
        shouldValidate: true,
      });
    }
  }, [
    JSON.stringify(allValues ?? {}),
    JSON.stringify(answers ?? {}),
    JSON.stringify(autoFillCondition),
    methods,
    question.name,
  ]);

  return null;
}
